/*
AnchorPosition.js
Author: Matt Kruse

DESCRIPTION: These functions find the position of an <A> tag in a document,
so other elements can be positioned relative to it.

COMPATABILITY: Netscape 4.x,6.x,Mozilla, IE 5.x,6.x on Windows. Some small
positioning errors - usually with Window positioning - occur on the
Macintosh platform.

FUNCTIONS:
getAnchorPosition(anchorname)
  Returns an Object() having .x and .y properties of the pixel coordinates
  of the upper-left corner of the anchor. Position is relative to the PAGE.

getAnchorWindowPosition(anchorname)
  Returns an Object() having .x and .y properties of the pixel coordinates
  of the upper-left corner of the anchor, relative to the WHOLE SCREEN.

NOTES:

1) For popping up separate browser windows, use getAnchorWindowPosition.
   Otherwise, use getAnchorPosition

2) Your anchor tag MUST contain both NAME and ID attributes which are the
   same. For example:
   <A NAME="test" ID="test"> </A>

3) There must be at least a space between <A> </A> for IE5.5 to see the
   anchor tag correctly. Do not do <A></A> with no space.
*/

// getAnchorPosition(anchorname)
//   This function returns an object having .x and .y properties which are the coordinates
//   of the named anchor, relative to the page.
function getAnchorPosition(anchorname) {
	// This function will return an Object with x and y properties
	var useWindow=false;
	var coordinates=new Object();
	var x=0,y=0;
	// Browser capability sniffing
	var use_gebi=false, use_css=false, use_layers=false;
	if (document.getElementById) { use_gebi=true; }
	else if (document.all) { use_css=true; }
	else if (document.layers) { use_layers=true; }
	// Logic to find position
 	if (use_gebi && document.all) {
		x=AnchorPosition_getPageOffsetLeft(document.all[anchorname]);
		y=AnchorPosition_getPageOffsetTop(document.all[anchorname]);
		}
	else if (use_gebi) {
		var o=document.getElementById(anchorname);
		x=AnchorPosition_getPageOffsetLeft(o);
		y=AnchorPosition_getPageOffsetTop(o);
		}
 	else if (use_css) {
		x=AnchorPosition_getPageOffsetLeft(document.all[anchorname]);
		y=AnchorPosition_getPageOffsetTop(document.all[anchorname]);
		}
	else if (use_layers) {
		var found=0;
		for (var i=0; i<document.anchors.length; i++) {
			if (document.anchors[i].name==anchorname) { found=1; break; }
			}
		if (found==0) {
			coordinates.x=0; coordinates.y=0; return coordinates;
			}
		x=document.anchors[i].x;
		y=document.anchors[i].y;
		}
	else {
		coordinates.x=0; coordinates.y=0; return coordinates;
		}
	coordinates.x=x;
	coordinates.y=y;
	return coordinates;
	}

// getAnchorWindowPosition(anchorname)
//   This function returns an object having .x and .y properties which are the coordinates
//   of the named anchor, relative to the window
function getAnchorWindowPosition(anchorname) {
	var coordinates=getAnchorPosition(anchorname);
	var x=0;
	var y=0;
	if (document.getElementById) {
		if (isNaN(window.screenX)) {
			x=coordinates.x-document.body.scrollLeft+window.screenLeft;
			y=coordinates.y-document.body.scrollTop+window.screenTop;
			}
		else {
			x=coordinates.x+window.screenX+(window.outerWidth-window.innerWidth)-window.pageXOffset;
			y=coordinates.y+window.screenY+(window.outerHeight-24-window.innerHeight)-window.pageYOffset;
			}
		}
	else if (document.all) {
		x=coordinates.x-document.body.scrollLeft+window.screenLeft;
		y=coordinates.y-document.body.scrollTop+window.screenTop;
		}
	else if (document.layers) {
		x=coordinates.x+window.screenX+(window.outerWidth-window.innerWidth)-window.pageXOffset;
		y=coordinates.y+window.screenY+(window.outerHeight-24-window.innerHeight)-window.pageYOffset;
		}
	coordinates.x=x;
	coordinates.y=y;
	return coordinates;
	}

// Functions for IE to get position of an object
function AnchorPosition_getPageOffsetLeft (el) {
	var ol=el.offsetLeft;
	while ((el=el.offsetParent) != null) { ol += el.offsetLeft; }
	return ol;
	}
function AnchorPosition_getWindowOffsetLeft (el) {
	return AnchorPosition_getPageOffsetLeft(el)-document.body.scrollLeft;
	}
function AnchorPosition_getPageOffsetTop (el) {
	var ot=el.offsetTop;
	while((el=el.offsetParent) != null) { ot += el.offsetTop; }
	return ot;
	}
function AnchorPosition_getWindowOffsetTop (el) {
	return AnchorPosition_getPageOffsetTop(el)-document.body.scrollTop;
	}

/* SOURCE FILE: PopupWindow.js */

/*
PopupWindow.js
Author: Matt Kruse
Last modified: 02/16/04

DESCRIPTION: This object allows you to easily and quickly popup a window
in a certain place. The window can either be a DIV or a separate browser
window.

COMPATABILITY: Works with Netscape 4.x, 6.x, IE 5.x on Windows. Some small
positioning errors - usually with Window positioning - occur on the
Macintosh platform. Due to bugs in Netscape 4.x, populating the popup
window with <STYLE> tags may cause errors.

USAGE:
// Create an object for a WINDOW popup
var win = new PopupWindow();

// Create an object for a DIV window using the DIV named 'mydiv'
var win = new PopupWindow('mydiv');

// Set the window to automatically hide itself when the user clicks
// anywhere else on the page except the popup
win.autoHide();

// Show the window relative to the anchor name passed in
win.showPopup(anchorname);

// Hide the popup
win.hidePopup();

// Set the size of the popup window (only applies to WINDOW popups
win.setSize(width,height);

// Populate the contents of the popup window that will be shown. If you
// change the contents while it is displayed, you will need to refresh()
win.populate(string);

// set the URL of the window, rather than populating its contents
// manually
win.setUrl("http://www.site.com/");

// Refresh the contents of the popup
win.refresh();

// Specify how many pixels to the right of the anchor the popup will appear
win.offsetX = 50;

// Specify how many pixels below the anchor the popup will appear
win.offsetY = 100;

NOTES:
1) Requires the functions in AnchorPosition.js

2) Your anchor tag MUST contain both NAME and ID attributes which are the
   same. For example:
   <A NAME="test" ID="test"> </A>

3) There must be at least a space between <A> </A> for IE5.5 to see the
   anchor tag correctly. Do not do <A></A> with no space.

4) When a PopupWindow object is created, a handler for 'onmouseup' is
   attached to any event handler you may have already defined. Do NOT define
   an event handler for 'onmouseup' after you define a PopupWindow object or
   the autoHide() will not work correctly.
*/

// Set the position of the popup window based on the anchor
function PopupWindow_getXYPosition(anchorname) {
	var coordinates;
	if (this.type == "WINDOW") {
		coordinates = getAnchorWindowPosition(anchorname);
		}
	else {
		coordinates = getAnchorPosition(anchorname);
		}
	this.x = coordinates.x;
	this.y = coordinates.y;
	}
// Set width/height of DIV/popup window
function PopupWindow_setSize(width,height) {
	this.width = width;
	this.height = height;
	}
// Fill the window with contents
function PopupWindow_populate(contents) {
	this.contents = contents;
	this.populated = false;
	}
// Set the URL to go to
function PopupWindow_setUrl(url) {
	this.url = url;
	}
// Set the window popup properties
function PopupWindow_setWindowProperties(props) {
	this.windowProperties = props;
	}
// Refresh the displayed contents of the popup
function PopupWindow_refresh() {
	if (this.divName != null) {
		// refresh the DIV object
		if (this.use_gebi) {
			document.getElementById(this.divName).innerHTML = this.contents;
			}
		else if (this.use_css) {
			document.all[this.divName].innerHTML = this.contents;
			}
		else if (this.use_layers) {
			var d = document.layers[this.divName];
			d.document.open();
			d.document.writeln(this.contents);
			d.document.close();
			}
		}
	else {
		if (this.popupWindow != null && !this.popupWindow.closed) {
			if (this.url!="") {
				this.popupWindow.location.href=this.url;
				}
			else {
				this.popupWindow.document.open();
				this.popupWindow.document.writeln(this.contents);
				this.popupWindow.document.close();
			}
			this.popupWindow.focus();
			}
		}
	}
// Position and show the popup, relative to an anchor object
function PopupWindow_showPopup(anchorname) {

	this.getXYPosition(anchorname);
	this.x += this.offsetX;
	this.y += this.offsetY;
	if (!this.populated && (this.contents != "")) {
		this.populated = true;
		this.refresh();
		}
	if (this.divName != null) {
		// Show the DIV object
		if (this.use_gebi) {
			document.getElementById(this.divName).style.left = this.x + "px";
			document.getElementById(this.divName).style.top = this.y + "px";
			document.getElementById(this.divName).style.visibility = "visible";
			}
		else if (this.use_css) {
			document.all[this.divName].style.left = this.x;
			document.all[this.divName].style.top = this.y;
			document.all[this.divName].style.visibility = "visible";
			}
		else if (this.use_layers) {
			document.layers[this.divName].left = this.x;
			document.layers[this.divName].top = this.y;
			document.layers[this.divName].visibility = "visible";
			}
		}
	else {
		if (this.popupWindow == null || this.popupWindow.closed) {
			// If the popup window will go off-screen, move it so it doesn't
			if (this.x<0) { this.x=0; }
			if (this.y<0) { this.y=0; }
			if (screen && screen.availHeight) {
				if ((this.y + this.height) > screen.availHeight) {
					this.y = screen.availHeight - this.height;
					}
				}
			if (screen && screen.availWidth) {
				if ((this.x + this.width) > screen.availWidth) {
					this.x = screen.availWidth - this.width;
					}
				}
			var avoidAboutBlank = window.opera || ( document.layers && !navigator.mimeTypes['*'] ) || navigator.vendor == 'KDE' || ( document.childNodes && !document.all && !navigator.taintEnabled );
			this.popupWindow = window.open(avoidAboutBlank?"":"about:blank","window_"+anchorname,this.windowProperties+",width="+this.width+",height="+this.height+",screenX="+this.x+",left="+this.x+",screenY="+this.y+",top="+this.y+"");
			}
		this.refresh();
		}
	}
// Hide the popup
function PopupWindow_hidePopup() {
	if (this.divName != null) {
		if (this.use_gebi) {
			document.getElementById(this.divName).style.visibility = "hidden";
			}
		else if (this.use_css) {
			document.all[this.divName].style.visibility = "hidden";
			}
		else if (this.use_layers) {
			document.layers[this.divName].visibility = "hidden";
			}
		}
	else {
		if (this.popupWindow && !this.popupWindow.closed) {
			this.popupWindow.close();
			this.popupWindow = null;
			}
		}
	}
// Pass an event and return whether or not it was the popup DIV that was clicked
function PopupWindow_isClicked(e) {
	if (this.divName != null) {
		if (this.use_layers) {
			var clickX = e.pageX;
			var clickY = e.pageY;
			var t = document.layers[this.divName];
			if ((clickX > t.left) && (clickX < t.left+t.clip.width) && (clickY > t.top) && (clickY < t.top+t.clip.height)) {
				return true;
				}
			else { return false; }
			}
		else if (document.all) { // Need to hard-code this to trap IE for error-handling
			var t = window.event.srcElement;
			while (t.parentElement != null) {
				if (t.id==this.divName) {
					return true;
					}
				t = t.parentElement;
				}
			return false;
			}
		else if (this.use_gebi && e) {
			var t = e.originalTarget;
			while (t.parentNode != null) {
				if (t.id==this.divName) {
					return true;
					}
				t = t.parentNode;
				}
			return false;
			}
		return false;
		}
	return false;
	}

// Check an onMouseDown event to see if we should hide
function PopupWindow_hideIfNotClicked(e) {
	if (this.autoHideEnabled && !this.isClicked(e)) {
		this.hidePopup();
		}
	}
// Call this to make the DIV disable automatically when mouse is clicked outside it
function PopupWindow_autoHide() {
	this.autoHideEnabled = true;
	}
// This global function checks all PopupWindow objects onmouseup to see if they should be hidden
function PopupWindow_hidePopupWindows(e) {
	for (var i=0; i<popupWindowObjects.length; i++) {
		if (popupWindowObjects[i] != null) {
			var p = popupWindowObjects[i];
			p.hideIfNotClicked(e);
			}
		}
	}
// Run this immediately to attach the event listener
function PopupWindow_attachListener() {
	if (document.layers) {
		document.captureEvents(Event.MOUSEUP);
		}
	window.popupWindowOldEventListener = document.onmouseup;
	if (window.popupWindowOldEventListener != null) {
		document.onmouseup = new Function("window.popupWindowOldEventListener(); PopupWindow_hidePopupWindows();");
		}
	else {
		document.onmouseup = PopupWindow_hidePopupWindows;
		}
	}
// CONSTRUCTOR for the PopupWindow object
// Pass it a DIV name to use a DHTML popup, otherwise will default to window popup
function PopupWindow() {
	if (!window.popupWindowIndex) { window.popupWindowIndex = 0; }
	if (!window.popupWindowObjects) { window.popupWindowObjects = new Array(); }
	if (!window.listenerAttached) {
		window.listenerAttached = true;
		PopupWindow_attachListener();
		}
	this.index = popupWindowIndex++;
	popupWindowObjects[this.index] = this;
	this.divName = null;
	this.popupWindow = null;
	this.width=0;
	this.height=0;
	this.populated = false;
	this.visible = false;
	this.autoHideEnabled = false;

	this.contents = "";
	this.url="";
	this.windowProperties="toolbar=no,location=no,status=no,menubar=no,scrollbars=auto,resizable,alwaysRaised,dependent,titlebar=no";
	if (arguments.length>0) {
		this.type="DIV";
		this.divName = arguments[0];
		}
	else {
		this.type="WINDOW";
		}
	this.use_gebi = false;
	this.use_css = false;
	this.use_layers = false;
	if (document.getElementById) { this.use_gebi = true; }
	else if (document.all) { this.use_css = true; }
	else if (document.layers) { this.use_layers = true; }
	else { this.type = "WINDOW"; }
	this.offsetX = 0;
	this.offsetY = 0;
	// Method mappings
	this.getXYPosition = PopupWindow_getXYPosition;
	this.populate = PopupWindow_populate;
	this.setUrl = PopupWindow_setUrl;
	this.setWindowProperties = PopupWindow_setWindowProperties;
	this.refresh = PopupWindow_refresh;
	this.showPopup = PopupWindow_showPopup;
	this.hidePopup = PopupWindow_hidePopup;
	this.setSize = PopupWindow_setSize;
	this.isClicked = PopupWindow_isClicked;
	this.autoHide = PopupWindow_autoHide;
	this.hideIfNotClicked = PopupWindow_hideIfNotClicked;
	}


var prod_popup = new PopupWindow("warr_detail_replace");
prod_popup.offsetY=-600;
prod_popup.offsetX=-1540;

/* Detail box end */


(function() {

var window_location = window.location;
var ws_protocol = window_location.protocol;

var objAgent = navigator.userAgent;
var int_exp = 0;
if (objAgent.indexOf("MSIE")!=-1) {
    int_exp = 1;
}

// Localize jQuery variable
var jQuery;
if (ws_protocol == 'https:') {
    var jquery_file = "https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js";
    var css_file = "https://www.newleafsc.net/warranty_selector/premiumhomesource/mw_style.css";
    //var boot_css = "https://www.newleafsc.net/warranty_selector/premiumhomesource/bootstrap.min.css";
    var basket_file = "https://www.washerdryercombo.com/on/demandware.store/Sites-Combo-Site/default/Cart-AddProduct";
    var jsonp_url_server_side = "https://www.newleafsc.net/warranty_selector/premiumhomesource/mw_ws_phs.php";
    var popup_file = "https://www.newleafsc.net/warranty_selector/premiumhomesource/popup.php";

} else {
    var jquery_file = "http://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js";
    var css_file = "http://www.newleafsc.net/warranty_selector/premiumhomesource/mw_style.css";
    var basket_file = "http://www.washerdryercombo.com/on/demandware.store/Sites-Combo-Site/default/Cart-AddProduct";
    var jsonp_url_server_side = "http://www.newleafsc.net/warranty_selector/premiumhomesource/mw_ws_phs.php";
    var popup_file = "http://www.newleafsc.net/warranty_selector/premiumhomesource/popup.php";
}

 /******** Load jQuery if not present *********/
if (window.jQuery === undefined || window.jQuery.fn.jquery !== '1.11.1') {
    var script_tag = document.createElement('script');
    script_tag.setAttribute("type","text/javascript");
    script_tag.setAttribute("src", jquery_file);
    //script_tag.setAttribute("src", boot_js);
    script_tag.onload = scriptLoadHandler;
    script_tag.onreadystatechange = function () { // Same thing but for IE
        if (this.readyState == 'complete' || this.readyState == 'loaded') {
            scriptLoadHandler();
        }
    };
    // Try to find the head, otherwise default to the documentElement
    (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(script_tag);
} else {
    // The jQuery version on the window is the one we want to use
    jQuery = window.jQuery;
    main();
}

/******** Called once jQuery has loaded ******/
function scriptLoadHandler() {
    // Restore $ and window.jQuery to their previous values and store the
    // new jQuery in our local jQuery variable
    jQuery = window.jQuery.noConflict(true);
    // Call our main function
    main();
}


/******** Our main function ********/
function main() {
    
    jQuery(document).ready(function($) {
        /******* Load CSS *******/
        var css_link = $("<link>", {
            rel: "stylesheet",
            type: "text/css",
            href: css_file
        });
     //   css_link.appendTo('head');
        $('head').append('<link rel="stylesheet" href="' + css_file + '" type="text/css" />');
        //$('head').append('<link rel="stylesheet" href="' + boot_css + '" type="text/css" />');
        //$('head').append('<script src="' + boot_js + '" type="text/javascript" />');
        //Jegathees added 08-01-2019
    //var script_boot = document.createElement('script');
    //script_boot.setAttribute("type","text/javascript");
    //script_boot.setAttribute("src", boot_js);


        // Custom extension for jQuery to retrieve query string variables
        $.extend({
            getUrlVars: function(){
            var vars = [], hash;
            var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
            for(var i = 0; i < hashes.length; i++) {
                hash = hashes[i].split('=');
                vars.push(hash[0]);
                vars[hash[0]] = hash[1];
            }
            return vars;
            },
            getUrlVar: function(name){
                return $.getUrlVars()[name];
            }
        });



        var detail_div = '<div name="warr_detail_replace" id="warr_detail_replace" style="visibility:hidden; position:absolute; width:830px; height:580px; z-index: 22;" class="mw_wty_detail_div"><div class="hlp_title" style="width:809px; height:129px; float: left;"><img src="https://www.newleafsc.net/warranty_selector/premiumhomesource/images/logo_nl.png" style="margin: 1px 2px -13px 0px; float: left;  padding-top:4px; padding-right:5px; padding-bottom:4px; padding-left:15px; vertical-align:top;"><div style="float:right;"><a href="#" onclick="javascript:prod_popup.hidePopup(); return false;" class="mw_close" style="text-decoration: none; color:#000; font-size:12px;"><span style="color:#B2191D; font-size:20px; line-height: 20px; margin: 0px -3px 0px 0px; font-weight: bold;">&times;</span></a>&nbsp;&nbsp;</div><table style="padding: 2px; width: 100%;"><tr style="border-bottom:1px solid #0E6B3A; line-height: 1px;"><td style="width: 320px; border-top: 0px; border-bottom:1px solid #0E6B3A;">&nbsp;</td><td style="border-bottom: 1px solid #0E6B3A; border-top: 0px;"><span style="vertical-align: bottom; padding: 2px 2px 2px 20px;"><a href="javascript:void();" id ="overview" onclick=load_nav("popup");  class="sel_nav">OVERVIEW</a></span></td><td style="border-bottom: 1px solid #0E6B3A; border-top: 0px;"><span style="vertical-align: bottom; padding: 2px 2px 2px 20px;"><a href="javascript:void();" id ="claims" onclick=load_nav("claims");  class="unsel_nav">CLAIMS</a></span></td><td style="border-bottom: 1px solid #0E6B3A; border-top: 0px;"><span style="vertical-align: bottom; padding: 2px 2px 2px 20px;"><a href="javascript:void();" id ="faq" onclick=load_nav("faq");  class="unsel_nav">FAQs</a></span></td><td style="width: 130px; border-bottom: 1px solid #0E6B3A; border-top: 0px;">&nbsp</td></tr></table></div><iframe src="'+popup_file+'" id="pop_frame" name ="pop_frame" width="824" height="620" frameborder="0" style="border-radius: 1rem;" scrolling="no"></iframe><div> <img src="https://www.newleafsc.net/warranty_selector/premiumhomesource/images/footer.png" style="width: 828px; margin: 0px 0px 0px 0px;"></div></div>';
        /* Code to populate warranty in basket */


        var page_name = window_location.pathname.replace(new RegExp("/on.*default/"),'');
        // Live implementation

        var submit_page_name = window_location.pathname.replace(new RegExp("/default/.*"),'/default/CheckoutCart-AddProduct');

        //var page_name = window_location.pathname.replace(new RegExp(".*/default/"),'');
        page_name = page_name.replace(new RegExp("CheckoutCart-.*"), 'Cart');
        page_name = page_name.replace(new RegExp("Cart-.*"), 'Cart');
        page_name = page_name.replace(new RegExp("/cart"), 'Cart');
        page_name = page_name.replace(new RegExp("cart"), 'Cart');

        var prod_price = 0;
        //if (page_name == 'Cart-AddProduct' || page_name == 'Cart-Show') {
        if (page_name == page_name) {
            prod_popup.offsetY=-400;
            prod_popup.offsetX=-700;
            var i = 0;
	    var k = 0;
            var arr_items = [];
	    var arr_sku = []; 
	    var arr_cart = [];
	    var basket_item_id = '';
	    $('h6.list-view-item__title').each(function() {
		var basket_item_id = $(this).find('a').html();
		//var arr_sku = basket_item_id.split(',');
		//var length = arr_sku.length;
		//basket_item_id = arr_sku[length-1];
		   // basket_item_id = trim(basket_item_id);
		var basket_item_id = $(this).find('a').attr('href');
		    basket_item_id = basket_item_id.split('=');
		    basket_item_id = basket_item_id[1];
//alert(basket_item_id);
		if (basket_item_id) {
		    basket_item_id = basket_item_id.replace(/[^0-9.]/g, '');
		    }
		   arr_items[i] = basket_item_id;
		var prod_desc = $(this).find('a').html();
		    prod_desc = unescape(prod_desc);
		if (prod_desc) {
		    prod_desc = trim(prod_desc);
		}
		var prod_price = $(this).parent().data('price');
		if (prod_price ==undefined) {
		var prod_price = $(this).closest('td').next('td').next('td').next('td').find('div:eq(0)').html();
		}
		if (prod_price) {
		    prod_price = prod_price.replace(/[^0-9.]/g, '');
		    }
		var prod_qty = $(this).parent().data('qty');
		prod_price = prod_price / prod_qty;

		var parent_div = $(this).parent().parent().find('.accordion .accordion-body');
		var parent_div_detail = $(this);//.closest('td');

		arr_cart.push({});
		arr_cart[i]['qty'] = prod_qty;
		arr_cart[i]['id'] = basket_item_id;
		arr_cart[i]['prod_price'] = prod_price;
		arr_cart[i]['prod_desc'] = prod_desc;
		arr_cart[i]['parent_div'] = parent_div;
		arr_cart[i]['parent_div_detail'] = parent_div_detail;
		arr_cart[i]['warranty_count'] = 0;
		arr_cart[i]['product_count'] = 1;
		i++;
            });
		$.each(arr_cart, function(m, value) {
            var form_action = submit_page_name;
            var parent_div = arr_cart[m]['parent_div'];
            var parent_div_detail = arr_cart[m]['parent_div_detail'];
		    var form_key = $('input[name=form_key]').val();
		    var prod_cat = '';

                    var warranty_exists = 0;
                    var prod_qs = "";
                    prod_qs += "prod_sku=" + encodeURIComponent(arr_cart[m]['id']);
                    prod_qs += "&prod_desc=" + encodeURIComponent(arr_cart[m]['prod_desc']);
                    prod_qs += "&prod_cat=" + encodeURIComponent(prod_cat);
                    prod_qs += "&prod_price=" + encodeURIComponent(arr_cart[m]['prod_price']);
                    prod_qs += "&action=" + encodeURIComponent(form_action);
                    prod_qs += "&form_key=" + encodeURIComponent(form_key);
                    prod_qs += "&page_url=" + encodeURIComponent(window_location);
                    prod_qs += "&add_to_cart=" + encodeURIComponent(1);
                    var jsonp_url = jsonp_url_server_side + "?" + prod_qs + "&callback=?";
		    $.getJSON(jsonp_url, function(data) {
//alert(data.warranty_id);
//alert(arr_items);
			if (data.warranty_count > 0) {
			    var reduced = 0;
                for (var j=0; j<arr_items.length; j++) {
                    for (var k=0; k<data.warranty_count; k++) {
                        if (arr_items[j] == data.warranty_id[k]) {
                            warranty_exists = 1;
                            for (var x=0; x<i; x++) {
                                if (arr_cart[x]['id'] == arr_items[j]) {
                                    arr_cart[m]['warranty_count'] = parseInt(arr_cart[m]['warranty_count']) + parseInt(arr_cart[x]['qty']);
                                    //arr_cart[x]['qty'] = parseInt(arr_cart[x]['qty']) - parseInt(arr_cart[m]['qty']);
                                    if (reduced == 0 && arr_cart[x]['qty'] > 0) {
                                    arr_cart[x]['qty'] = parseInt(arr_cart[x]['qty']) - 1;
                                	reduced = 1;
                                }
                                    //arr_cart[x]['product_count'] = parseInt(arr_cart[x]['product_count']) + 1;
                                }
                            }
                        }
                    }
                }
            }
			
		    if (warranty_exists == 0) {
		        parent_div_detail.after(detail_div);
			    parent_div.html(data.html);
				if (data.html) {
					parent_div.parent().parent().parent().removeClass('hide');
				}
		    } else if ((parseInt(arr_cart[m]['product_count']) > parseInt(arr_cart[m]['warranty_count']))) {
		    	parent_div_detail.after(detail_div);
			    parent_div.html(data.html);
		    }

			m++;
                    });
		});
        } else {

	var detail_div = '<div class="modal fade" id="mwModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header">New Leaf ServicePro Warranty<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button></div><div class="modal-body"><div id="image-container"><img src="https://www.compactappliance.com/on/demandware.static/Sites-Appliance-Site/-/default/v1/images/newleaf/servicepro_popup.jpg" align="left" alt="" border="0" style="padding-right:5px; margin-bottom:20px;" />New Leaf ServicePro Service Plans provide Peace of Mind by extending the manufacturer\'s warranty and providing additional coverage. This peace of mind is offered in terms of 1, 3 and 5 years. The 5 year plan offers the added benefit of  a REBATE!  This rebate comes in the form of a coupon that can be redeemed for half the price of the warranty if there is no need to use the warranty during the 5 years of coverage. A commercial usage add on to all warranties is also available by contacting our customer service department.</p><p>Some of the items purchased on our site qualify for New Leaf\'s Replacement Only Contracts. Should an item that is covered by these plans become defective they are simply replaced instead of repaired.</p><p>This plan is an economical way to extend your product\'s manufacturer parts and labor warranty. Even the best products can eventually malfunction and minor repairs can cost hundreds of dollars. By purchasing a New Leaf ServicePro Service Plan, you won\'t have to hassle with unexpected repair bills.</p><p>Service is easy to obtain. You can contact New Leaf online at www.newleafservicepro.com or call 1-855-TRY NEW LEAF (1.855.879.639.5323). The call center is open 24 hours a day, 365 days a year. You will be notified of the nearest service center. You will have access to more than 12,000 authorized service centers nationwide.</p><p class="pNoBottomPad"><b>Service Plan Benefits</b></p><ul><li><b>Fully Insured for Parts and Labor</b><br>This plan is fully insured by an insurance company rated A- (Excellent) by A.M. Best. This covers parts and labor for repair or replacement up to the value of your product, during the term of the plan.<li><b>Toll Free Number</b><br>You can call the toll free number 7 days a week 24 hours a day with questions regarding your service plan or if your product needs repair.<li><b>Pre-screened & Authorized Service Providers</b><br>ServicePro has a network of pre-screened, fully insured, manufacturer authorized service centers.<li><b>Repair or Replace Promise</b><br>If ServicePro can\'t repair the covered product, they will replace it with a product of like features and functionality.<li><b>No Deductibles or Hidden Charges - 100% Coverage of Parts and Labor</b><br>There is no need to worry about hidden charges.  ServicePro covers repairs to the product in the event of an electrical or mechanical failure.<li><b>Plan is Transferable</b><br>In the event that the covered product is sold or transferred at anytime during the term of the Service Plan then the coverage may be transferred to the new owner.<li><b>Renewable</b><br>At the end of the prescribed term, you have the option to renew the service plan.<li><b>Multiple Repair Safeguard</b><br>Rest assured that ServicePro will replace your customer\'s product should the product require more than 3 qualified service events during a 12 month period. (After the expiration of the manufacturer\'s warranty.)<li><b>Food Loss Protection</b><br>ServicePro protects you in the event you experience food loss as the result of an electrical or manufacturer failure.  $200 per qualified event.<li><b>Power Surge Protection</b><br>ServicePro protects your unit in the event of a power surge up to a maximum of $500. Product must be plugged in to a UL approved surge protector. (Not required for major appliances)</ul></div><div class="modal-footer"><button type="button" class="btn btn-close" data-dismiss="modal">Close</button></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal -->';
	
        var prd_id = $('input[name=pid]').val();

	var price_holder = $('div[id=priceblock]').find('span[class=productPrice]').html();
	if (price_holder) {
	    prod_price = price_holder.replace(/[^0-9.]/g, '');
	}

//alert('prd_id = ' + prd_id);
//alert('prod_price = ' + prod_price);

        var form_action = "product_detail.php";
        //var warr_div = $('div[class=variations]');
        //var warr_div = $('input[class=addToCartButton01]');
        warr_div = $('#quantitySubTotalRow');

        var prod_desc = $('h1').html();
        prod_desc = prod_desc.replace(new RegExp('<span itemprop="name">', 'i'), '');
        prod_desc = trim(prod_desc);
	if (s) {
            var prod_cat = s.prop1;
	} else {
            var prod_cat = '';
	}

        var frm_cart = $('form[class=addtocart]');

        var prod_qs = "";
        prod_qs += "prod_sku=" + encodeURIComponent(prd_id);
        prod_qs += "&prod_desc=" + encodeURIComponent(prod_desc);
        prod_qs += "&prod_cat=" + encodeURIComponent(prod_cat);
        prod_qs += "&prod_price=" + encodeURIComponent(prod_price);
        prod_qs += "&action=" + encodeURIComponent(form_action);
        prod_qs += "&page_url=" + encodeURIComponent(window_location);
        prod_qs += "&add_to_cart=" + encodeURIComponent(0);
        var jsonp_url = jsonp_url_server_side + "?" + prod_qs + "&callback=?";
        $.getJSON(jsonp_url, function(data) {
            var ws_box = data.html + detail_div;
	    warr_div.after(ws_box);

        });
        }
    });
  }
})(); // We call our anonymous function immediately


// Trim functions
function trim(stringToTrim) {
	return stringToTrim.replace(/^\s+|\s+$/g,"");
}
function ltrim(stringToTrim) {
	return stringToTrim.replace(/^\s+/,"");
}
function rtrim(stringToTrim) {
	return stringToTrim.replace(/\s+$/,"");
}
function addtocart(prod_id, ws_prod) {
	//var json_url_server = "http://beta.autoplicity.com/addproducttocart/details/";
	var json_url_server = "/addproducttocart/details/";
	var jsonp_url = json_url_server  + prod_id + "/1?ws_product_id=" + ws_prod;
//alert(jsonp_url);
	$.post(jsonp_url, function(data) {
	if (data.redirect == "/cart") {
	 window.location = "/cart";
		}
	});
}

function load_nav(nav) {
	document.getElementById('pop_frame').src = "https://www.newleafsc.net/warranty_selector/premiumhomesource/"+nav+".php";
	if (nav =='popup') {
	document.getElementById("overview").className = "sel_nav";
	document.getElementById("claims").className = "unsel_nav";
	document.getElementById("faq").className = "unsel_nav";
	} else if (nav =='claims') {
	document.getElementById("claims").className = "sel_nav";
	document.getElementById("overview").className = "unsel_nav";
	document.getElementById("faq").className = "unsel_nav";
	} else if (nav =='faq') {
	document.getElementById("faq").className = "sel_nav";
	document.getElementById("overview").className = "unsel_nav";
	document.getElementById("claims").className = "unsel_nav";
	}
}
//:set tabstop=4 softtabstop=4 shiftwidth=4 noexpandtab
